var _rect, _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEmptyImage = function SvgEmptyImage(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 291,
    height: 159,
    viewBox: "0 0 291 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 290.6,
    height: 158.6,
    fill: "url(#paint0_linear_5408_296766)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M149.5 66.6C149.5 64 151.6 61.9 154.2 61.9C156.8 61.9 158.9 64 158.9 66.6C158.9 69.2 156.8 71.3 154.2 71.3C151.6 71.3 149.5 69.2 149.5 66.6Z",
    fill: "#314C63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.1 99.3H169.2L153.5 80.5L146.9 88.5L138 74.9L122.1 99.3ZM158.9 94.5H150.9L149.7 92.7L153.5 88.1L158.9 94.5ZM131 94.5L138 83.7L145 94.5H131Z",
    fill: "#314C63"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M172.7 106.7H102V111.9H112.6V122.6H117.8V111.9H177.9V55.9H172.7V106.7Z",
    fill: "#314C63"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M177.9 46.6V36H172.7V46.6H112.6V102.7H117.8V51.8H188.6V46.6H177.9Z",
    fill: "#314C63"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5408_296766",
    x1: 0.00000212778,
    y1: 74.7943,
    x2: 128.19,
    y2: 269.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39ACDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B4F69"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEmptyImage);
export { ForwardRef as ReactComponent };